"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsFeatureHasAnOption = exports.getFeatureOptionByName = void 0;

var _ssr = require("./ssr");

var getFeatureOptionByName = function getFeatureOptionByName(featureName) {
  if (_ssr.isSSR) return undefined;
  var feature = window[featureName];

  if (!feature) {
    // eslint-disable-next-line no-console
    console.error("\u041D\u0435 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u043E \u0444\u0438\u0447\u0438 \u0441 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C ".concat(featureName, ". \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u0443\u044E \u0431\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u0438 \u043F\u043E\u043C\u043E\u0449\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B lt download-table features"));
  }

  return feature;
};

exports.getFeatureOptionByName = getFeatureOptionByName;

var getIsFeatureHasAnOption = function getIsFeatureHasAnOption(featureName, optionName) {
  return getFeatureOptionByName(featureName) === optionName;
};

exports.getIsFeatureHasAnOption = getIsFeatureHasAnOption;